export { Page } from './container';
export { getData } from './functions';
export { useColoredBackground } from './hooks';
